import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import HelpTooltip from '../help/HelpTooltip';
import { grey } from '@mui/material/colors';
import { ManageHistory } from '@mui/icons-material';
import { ETLLastUpdate, useGetAppContextQuery } from '../redux/appContext';
import { getFormatedStringFromDate } from '../utils/dateUtils';

export const AppContextCtrl: React.FC = () => {
const appContext: ReturnType<typeof useGetAppContextQuery> = useGetAppContextQuery(undefined, { skip: false });
const [lastUpdates, setLastUpdates] = React.useState<ETLLastUpdate[]>([]);

    React.useEffect(() => {
        if (appContext.isSuccess && appContext.data) {
            setLastUpdates(appContext.data);
        }
    }, [appContext.isSuccess, appContext.data]);

    const itemsPerColumn = Math.ceil(lastUpdates.length / 3);
    const columns = [
        lastUpdates.slice(0, itemsPerColumn),
        lastUpdates.slice(itemsPerColumn, itemsPerColumn * 2),
        lastUpdates.slice(itemsPerColumn * 2)
    ];

    return (
        <HelpTooltip
            enterTouchDelay={0}
            enterNextDelay={5000}
            slotProps={{
                tooltip: {
                    sx: {
                        maxWidth: 'none'
                    }
                }
            }}
            title={
                <Box>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', textDecoration: 'underline', mb: 1.5 }}>
                        Datasources last updates
                    </Typography>
                    <Stack direction="row" spacing={3}>
                        {columns.map((columnItems, colIndex) => (
                            <Stack 
                                key={colIndex}
                                spacing={2}
                                sx={{ pl: colIndex > 0 ? 2 : 0 }}
                            >
                                {columnItems.map((etlStep) => (
                                    <Box key={etlStep.rank} sx={{ borderLeft: colIndex > 0 ? `1px solid white` : 'none', paddingLeft:'1em' }} >
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '0.875rem', mb: 0.5 }}>
                                            {etlStep.label}
                                        </Typography>
                                        <Typography sx={{ fontSize: '0.8rem', color: grey[100] }}>
                                            {getFormatedStringFromDate(etlStep.lastUpdate)}
                                        </Typography>
                                        <Typography sx={{ fontSize: '0.7rem', color: grey[400], mt: 0.5 }}>
                                            Frequency: {etlStep.frequency}
                                        </Typography>
                                    </Box>
                                ))}
                            </Stack>
                        ))}
                    </Stack>
                </Box>
            }
        >
            <ManageHistory 
                color={lastUpdates.length !== 0 ? 'action' : 'disabled'} 
                sx={{ marginTop: '8px' }} 
            />
        </HelpTooltip>
    );
}

export default AppContextCtrl;


